import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';
import { style } from '../../../components/pdf/fontstyles';

const getNextDay = (dateStr) => {
  if (!dateStr) return 'N/A';
  const [d, m, y] = dateStr.split('/');
  return new Date(y, m-1, +d+1).toLocaleDateString('en-GB');
};
        
const nonemployement = ({ result }) => {
  const nextDay = getNextDay(result?.dateOfRetirement);
    
    
    
    
    
    return(


              <View size="A4" style={style.page}> 
                 <Text style={[style.title, style.ArialBlack]}>NON EMPLOYMENT CERTIFICATE</Text>
                
                <View style={style.solidLine} />
               
                <Text style={[style.paragraph, { marginTop: 20 }]}>
              I , {result.employeeName} , {result.designation}Hereby Declare that after my retirement i.e. from {nextDay} I am not re-employed in any recognized educational Institution .
                </Text>
                      
           
                   <Text style={[style.paragraph, {marginTop:10 ,marginBottom: 10,textAlign: 'center'}]}>OR</Text>   
           
            <Text style={[style.paragraph, { marginTop: 20 }]}>
              I hereby declare that after my retirement i. e. from {result.nextDays} I am re employed in the same School / Institution from …NA…….. to……NA…….. and my basic pay during that period is ……NA……
            </Text>

                <Text style={[style.signature, {marginTop: 40}]}>{result.employeeName}</Text>
                <Text style={[style.signature, {marginTop: 80}]}>Head of Office</Text>

          
           </View>

);
};
export default nonemployement;